// extracted by mini-css-extract-plugin
export default {"root":"CH44_","container":"C61D_","icon":"HKjTI","title":"vxuQe","body":"DVJbX","buttons":"UNriD","button":"xE_zz","mobile":"R5yxl"};